import { useEffect, useState } from "react";
import $ from "jquery";
import DirectionRotation from "./layouts/DirectionRotation";
import { Box } from "@mui/material";

import { LeftBar } from "./layouts/SideBar";

const { availWidth, availHeight } = window.screen;
const screenWidth = Math.max(availWidth, availHeight);
const screenHeight = Math.min(availWidth, availHeight);
const device = getDevice();

function getDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return "windows";
  }
  if (/android/i.test(userAgent)) {
    return "android";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return undefined;
}

function App() {
  const [direction, setDirection] = useState("land");
  const [isLogined, setUserLogined] = useState(false);

  const setCanvasSize = () => {
    const { innerWidth, innerHeight } = window,
      dir = innerWidth > innerHeight ? "land" : "port";
    const pageWidth = dir === "land" ? screenWidth : screenHeight,
      pageHeight = dir === "port" ? screenWidth : screenHeight;
    const w = device === "ios" ? pageWidth : innerWidth;
    const m = device ? w * 0.7 : 1000;
    let directions = "";

    const wWidth = $(window).width();
    const wHeight = $(window).height();

    if (wHeight > wWidth) {
      directions = "port";

      $(".main-content-div").css("background", "#0c0b0b");
    } else {
      $(".main-content-div").css("background", "");

      directions = "land";
    }

    setDirection(directions);
  };

  useEffect(() => {
    setCanvasSize();
    window.addEventListener("resize", setCanvasSize, false);
  }, []);

  const updateLoginStatus = (status) => {
    setUserLogined(status);
  };
  return (
    <div className="App">
      <DirectionRotation deviceDirection={direction} />
      <div
        className={`main-content-div ${
          direction === "port" ? "main-content-inactive" : "main-content-active"
        }`}
      >
        <LeftBar />
      </div>
    </div>
  );
}

export default App;
